import React from 'react';
import { remCalc } from '../../../util/style-util';
import { Resource } from 'types';
import { makeStyles } from '@mui/styles';
type Props = {
  resource: Resource;
};

function ResourceItemContent(props: Props) {
  const { resourceItemContent, resourceTitle, resourceSubtitle } = useStyles();

  return (
    <div className={resourceItemContent}>
      <span className={resourceTitle}>{props.resource.title}</span>
      <span className={resourceSubtitle}>{props.resource.description}</span>
    </div>
  );
}
const useStyles = makeStyles(() => ({
  resourceItemContent: {
    padding: '15px 20px 20px 15px',
    position: 'relative',
    height: remCalc(190),
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column'
  },
  resourceTitle: {
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: remCalc(18),
    textOverflow: 'ellipsis',
    width: '100%',
    overflow: 'hidden',
    marginBottom: remCalc(9),
    maxHeight: remCalc(77)
  },
  resourceSubtitle: {
    fontStyle: 'normal',
    fontWeight: 300,
    fontSize: remCalc(18),
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    width: '100%',
    maxHeight: remCalc(77)
  }
}));

export default ResourceItemContent;
